// 🔒 JORNADA-CERRADA-2026-10-26 — fechas de la jornada como las ve el cliente en RD.
const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

// 2026-10-25 → "25/10/2026" (sin pasar por Date: la fecha de la jornada no tiene hora ni zona).
export function fechaCorta(fecha) {
  const [a, m, d] = String(fecha || '').split('-');
  return a && m && d ? `${d}/${m}/${a}` : String(fecha || '');
}

// 2026-10-25 → "domingo 25/10/2026"
export function fechaLarga(fecha) {
  const [a, m, d] = String(fecha || '').split('-').map(Number);
  if (!a || !m || !d) return String(fecha || '');
  return `${DIAS[new Date(Date.UTC(a, m - 1, d)).getUTCDay()]} ${fechaCorta(fecha)}`;
}

// Fecha de HOY en RD (YYYY-MM-DD). Antes se usaba la de UTC: después de las 8 PM proponía la de mañana.
export function hoyRD(ahora = new Date()) {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Santo_Domingo', year: 'numeric', month: '2-digit', day: '2-digit',
  }).format(ahora);
}
